/** Units on the server settings screen (spec §8.26): a number field shows the raw value; this gives
 *  the reader the same value in a unit they can read at a glance. */
export function readable(value: number, unit: "s" | "bytes" | "p" | null, locale: string): string | null {
  const n = (v: number, digits = 1) => v.toLocaleString(locale, { maximumFractionDigits: digits });
  if (unit === "bytes") {
    if (value >= 1e9) return `${n(value / 1e9)} GB`;
    if (value >= 1e6) return `${n(value / 1e6)} MB`;
    if (value >= 1e3) return `${n(value / 1e3)} kB`;
    return null;
  }
  if (unit === "s") {
    if (value >= 86_400 && value % 3600 === 0) return `${n(value / 86_400)} d`;
    if (value >= 3600) return `${n(value / 3600)} h`;
    if (value >= 60) return `${n(value / 60)} min`;
    return null;
  }
  return null;
}
